export class Pagination {
  public currentPage = 0;
  public nbPages: number = 0;
  public nbItems: number = 0;
  public nbItemsPerPage: number = 0;

  constructor(data: any = {}) {
    if (data) {
      this.currentPage = data.number + 1;
      this.nbPages = data.totalPages;
      this.nbItems = data.totalElements;
      this.nbItemsPerPage = data.size;
    }
  }
}
